import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { faqs } from '../../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <PageSection labelledBy="faq-title" className="bg-carbon-900" data-id="element-84" data-mp="urko47xxef4y">
      <SectionHeading id="faq-title" title="Preguntas frecuentes" data-id="element-85" data-mp="729pox41swtz" />
      <ul className="mt-8 space-y-3" data-id="element-86" data-mp="22di6nw56n9o">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        const panelId = `faq-panel-${i}`;
        return <li key={f.q} className={`rounded-lg border bg-carbon-950 transition-colors duration-200 ${isOpen ? 'border-accent-500/60' : 'border-carbon-800'}`} data-id="element-87" data-mp="h0pf8vnffy1d" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 rounded-lg px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400/50" data-id="element-88" data-mp="1sdrtvl5yudiw">
                <span className="font-display text-lg font-bold uppercase leading-snug tracking-wide text-white md:text-xl" data-id="element-89" data-mp="msaombyp427f">{f.q}</span>
                <PlusIcon className={`h-5 w-5 shrink-0 text-accent-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-90" data-mp="rsey3i16rwo5" />
              </button>
              <AnimatePresence initial={false} data-id="element-91" data-mp="3v9x37hpkqpkv">
                {isOpen && <motion.div id={panelId} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-92" data-mp="422s4cpi4a07">
                    <div className="space-y-1.5 px-5 pb-5 text-base leading-relaxed text-carbon-300" data-id="element-93" data-mp="3gjhjk7ct3pot">
                      {f.a.map(line => <p key={line} data-id="element-94" data-mp="noh95fvgc8ae">{line}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </PageSection>;
}